import axios from 'axios';
import useSWR from 'swr';

const useCleanUpCostDataRuns = (filters = {}) => {
  const searchParams = new URLSearchParams();

  if (filters.companyUid) {
    searchParams.set('companyUid', filters.companyUid);
  }

  const query = searchParams.toString();
  const url = `/admin/clean-up-cost-data-run${query ? `?${query}` : ''}`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useCleanUpCostDataRuns };
